import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';
import { birthday } from '../../../../model/birthday';
import { BirthdayItem } from './BirthdayItem';

interface IProps extends StyledComponentProps {
    birthdayList: Array<birthday>;
    onBirthdayClick: (sub: string) => void;
    selected: string;
}

export const BirthdayList = (props: IProps) => {
    const classes = props.classes;
    return (
    <List className={classes.root}>
        {props.birthdayList && props.birthdayList.map((c, index) =>
            <BirthdayItem
                classes={classes}
                isSelected={props.selected === c._id}
                birthday={c}
                onBirthdayClick={props.onBirthdayClick}
                key={c.name + c.surname + c.age + index}
            />)}
    </List>)
};